<template>
  <transition name="fade">
    <section class="section_dethi">
      <div class="ss-breadcrumb">
        <div class="container-hts">
          <ul class="margin-0 p-0">
            <li>
              <router-link :to="{ name: 'ebook' }">Sách điện tử</router-link>
            </li>
          </ul>
        </div>
      </div>
      <template v-if="!isMobile">
        <!-- :style="{background: `url(${imgBanner}) center center / cover no-repeat`}" -->
        <div
          class="
            ss-banner ss-banner--shadow-img ss-banner--ebook ss-banner--not-bg
          "
        >
          <!-- <img src="@/assets/images/book/banner_sdt.jpg" alt="Sách điện tử"> -->
          <div class="container-hts">
            <div
              class="ss-banner__wrap display-flex-end justify-content-between"
            >
              <!--  <div class="ss-banner__book-icons">
                <a v-for="(item, index) in filters.bookTypes" href="javascript:;" :class="{'active': item.bookTypeId === selectType}" @click="filterByType(item.bookTypeId)">
                  <img v-if="item.bookTypeId === 3" src="@/assets/images/book/book_type_1.png" :alt="item.name">
                  <img v-else-if="item.bookTypeId === 4" src="@/assets/images/book/book_type_2.png" :alt="item.name">
                </a>
              </div> -->
              <div class="ss-banner__classes" v-if="filters && filters.classes">
                <span class="ss-banner__classes__name">Lớp</span>
                <ul class="ss-banner__classes__list p-0 margin-0">
                  <li v-for="(item, index2) in filters.classes" :key="index2">
                    <a
                      href="javascript:;"
                      :class="{ active: item.classId === selectClass }"
                      @click="filterByClass(item.classId)"
                    >
                      <img
                        v-if="item.classId === selectClass && item.classNo != 0"
                        src="@/assets/images/bg-number.png"
                        :alt="item.classNo"
                      />
                      <img
                        v-if="
                          item.classId === selectClass && item.classNo === 0
                        "
                        src="@/assets/images/bg-number.png"
                        :alt="item.classNo"
                        style="max-width: inherit; width: 90px; right: -10px"
                      />
                      <span v-if="item.classNo === 0" class="font-sanpro-bold">
                        <span class="mn">Mầm non</span>
                      </span>
                      <span v-else class="font-sanpro-bold">{{
                        item.classNo
                      }}</span>
                      <!-- {{ item.classNo<10 ? ('0'+item.classNo): item.classNo }} -->
                    </a>
                  </li>
                </ul>
              </div>
              <!-- <div class="ss-banner__select">
                <div class="select-custom">
                  <select class="select_search secondary-color-txt border-rd-20 font-size-15 full-width" v-model="selectType" @change="filterByType($event)">
                    <option value="0">Tất cả</option>
                    <option v-for="(item, index) in filters.bookTypes" :key="index" :value="item.bookTypeId">{{ item.name }}</option>
                  </select>
                  <i class="fas fa-chevron-down"></i>
                </div>
              </div>-->
            </div>
          </div>
        </div>
        <EBookList_PC />
      </template>
      <EBookList_Mobi
        v-else-if="filters && filters.classes"
        :selectClass="selectClass"
        :classes="filters.classes"
        @filterClass="filterByClass"
      />
    </section>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { STORE_KEY } from "../_store/constants";
import store from "../_store";
import EBookFilter from "./EBookFilter";
import { APP_CONFIG } from "@/utils/constants";
import EBookList_PC from "./EBookList_PC";
import EBookList_Mobi from "./EBookList_Mobi";
import FilterMobile from "./ebooklist/FilterMobile";
const imgNext = require("@/assets/images/next.png");
const imgPrev = require("@/assets/images/prev.png");
const imgBookType1 = require("@/assets/images/book/book_type_1.png");
const imgBookType2 = require("@/assets/images/book/book_type_2.png");
const imgBanner = require("@/assets/images/banner.png");

export default {
  name: "EBookList",
  components: {
    EBookFilter,
    EBookList_PC,
    EBookList_Mobi,
    FilterMobile,
  },
  data() {
    return {
      windowWidth: 0,
      filterType: 0,
      imgNext,
      imgPrev,
      imgBookType1,
      imgBookType2,
      imgBanner,
      cdnUrl: APP_CONFIG.cdnUrl,
      selectType: 0,
      selectClass: 1,
    };
  },
  computed: {
    ...mapGetters({
      ebooks: STORE_KEY + "/ebooks",
      filterObj: STORE_KEY + "/ebooksFilter",
      filters: STORE_KEY + "/filters",
    }),
    isMobile() {
      return this.windowWidth < 991 ? true : false;
    },
    classActiveQuery() {
      return this.$route.query.classes
        ? parseInt(this.$route.query.classes)
        : 1;
    },
  },
  created() {
    this.$store.dispatch(STORE_KEY + "/getFilters");
    this.$store.dispatch(STORE_KEY + "/getEBooks", {
      classes: [this.classActiveQuery],
    });
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener("resize", this.getWindowWidth);
      //Init
      this.getWindowWidth();
    });
    if (this.classActiveQuery) {
      this.selectClass = parseInt(this.classActiveQuery);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowWidth);
  },
  methods: {
    getWindowWidth(event) {
      this.windowWidth = document.getElementsByTagName("body")[0].clientWidth;
    },

    filterByClass(classId) {
      if (classId !== this.selectClass) {
        this.selectClass = classId;
        this.$router.replace({
          name: "ebook",
          query: { book_active: 0, classes: classId },
        });
        if (this.selectType > 0 && this.selectClass > 0) {
          this.$store.dispatch(STORE_KEY + "/getEBooks", {
            book_type: [this.selectType],
            classes: [this.selectClass],
          });
        } else if (this.selectClass > 0) {
          this.$store.dispatch(STORE_KEY + "/getEBooks", {
            classes: [this.selectClass],
          });
        } else {
          this.$store.dispatch(STORE_KEY + "/getEBooks", {});
        }
      }
    },
  },
};
</script>
<style scoped>
.mn {
  font-size: 20px;
  position: absolute !important;
  right: 0;
}
</style>